import ItemComplexList from 'core/modules/components/general/ItemComplexList';
import { stripHtml } from 'core/utils/utils';
import moment from 'moment';
import PropTypes from 'prop-types';
import React from 'react';
import { withTranslation } from 'react-i18next';

const NextEventItem = ({ name, start, detail, onClickView, t, description, type, typeView }) => {
  function renderLeftInfo() {
    return (
      <div className="next-event-item__left">
        <span className="next-event-item__day"> {moment(start).format('DD')}</span>
        <span className="next-event-item__month">{moment(start).format('MMM')}</span>
      </div>
    );
  }

  function renderCenterInfo() {
    return (
      <div className="next-event-item__center">
        <span className="next-event-item__title" title={stripHtml(name)}>
          {stripHtml(name)}
        </span>
        {<span className="next-event-item__detail">{typeView === 'student' ? t(`events:${type}`) : detail}</span>}
      </div>
    );
  }

  function renderRightInfo() {
    // return <>{onClickView && <span className="next-event-item__view"> {t('View')}</span>}</>;
  }

  function clickOnEvent(e) {
    e.stopPropagation();
    onClickView();
  }

  return (
    <div className="next-event-item" onClick={clickOnEvent}>
      <ItemComplexList center={renderCenterInfo()} left={renderLeftInfo()} right={renderRightInfo()} />
    </div>
  );
};

NextEventItem.propTypes = {
  name: PropTypes.string,
  start: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  detail: PropTypes.string,
  onClickView: PropTypes.func,
  typeView: PropTypes.string,
};

NextEventItem.defaultProps = {
  start: new Date().toString(),
  typeView: 'default',
};

export default withTranslation(['actions'])(NextEventItem);
